import { Controller } from "@hotwired/stimulus"
import { onMorph } from "../lib/reactor"

export default class extends Controller {
  connect() {
    onMorph(this)
    this.shown = this.rowIds
  }

  // Idiomorph detaches and re-inserts kept rows when one is prepended, which restarts their CSS animation.
  // getAnimations walks every animation in the document, so it runs once, and only when a row came in.
  morph() {
    const shown = this.shown
    this.shown = this.rowIds
    if ([...this.shown].every((id) => shown.has(id))) return

    for (const animation of this.element.getAnimations({ subtree: true })) {
      const target = animation.effect?.target
      if (!target?.closest(".scaling-event-track")) continue
      if (shown.has(target.closest(".scaling-event-row")?.id)) animation.finish()
    }
  }

  get rows() {
    return this.element.querySelectorAll(".scaling-event-row[id]")
  }

  get rowIds() {
    return new Set(Array.from(this.rows, (row) => row.id))
  }
}
